import React from 'react';
import { Button } from '../components/Button';
import { motion } from 'framer-motion';
export const CTASection: React.FC = () => {
  return <section id="contacto" className="py-24 bg-remax-dark relative overflow-hidden" data-id="element-85">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-86">
        <div className="absolute top-0 -left-4 w-72 h-72 bg-remax-red rounded-full mix-blend-multiply filter blur-3xl" data-id="element-87"></div>
        <div className="absolute bottom-0 -right-4 w-72 h-72 bg-remax-blue rounded-full mix-blend-multiply filter blur-3xl" data-id="element-88"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-90">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-91">
            ¿Listo para Transformar REMAX Domus?
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-92">
            Elige el modelo que mejor se adapte a tu estrategia y comienza a
            generar leads hoy mismo con el poder de Demand OS.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-93">
            <Button variant="secondary" className="w-full sm:w-auto" data-id="element-94">
              Solicitar Demo
            </Button>
            <Button variant="primary" className="w-full sm:w-auto" data-id="element-95">
              Descargar Propuesta
            </Button>
            <Button variant="outline" className="w-full sm:w-auto bg-transparent text-white border-white hover:bg-white/10" data-id="element-96">
              Contactar a Dwhight
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
};